'use client'

import React, { useState } from 'react'
import classNames from 'classnames'
import { m } from 'framer-motion'
import MarketoForm from '@hashicorp/react-components/src/components/marketo-form'
import type { MarketoFormAPIResponse } from '@hashicorp/react-components/src/components/marketo-form/types'
import SubmitMessage from './submit-message'
import s from './style.module.css'

export interface NewsletterSignupFormProps {
	marketoFormData: MarketoFormAPIResponse
	placement?: 'footer'
	buttonText?: string
	appearance?: 'light' | 'dark'
}

export type MarketoFormData = MarketoFormAPIResponse

function NewsletterSignupForm({
	placement,
	buttonText = 'Subscribe',
	appearance = 'light',
	marketoFormData,
}: NewsletterSignupFormProps) {
	const [submissionStatus, setSubmissionStatus] = useState(null)

	const onSubmitSuccess = () => {
		setSubmissionStatus('success')
		if (window && window.analytics && placement) {
			window.analytics.track('Newsletter Signup', { placement })
		}
	}

	const onSubmitError = () => {
		setSubmissionStatus('error')
	}

	return (
		<div
			className={classNames(s.formWrapper, {
				['hdsplus-dark-mode']: appearance === 'dark',
			})}
			data-test-id="newsletterSignupForm"
		>
			{submissionStatus ? (
				<m.div
					className={s.submissionStatus}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					transition={{ duration: 0.3, delay: 0.2 }}
				>
					<SubmitMessage
						submitStatus={submissionStatus}
						appearance={appearance}
					/>
				</m.div>
			) : null}
			<m.div
				inert={submissionStatus ? true : undefined}
				animate={{ opacity: submissionStatus ? 0 : 1 }}
				transition={{ duration: 0.3 }}
			>
				<MarketoForm
					{...marketoFormData}
					submitTitle={buttonText}
					className={classNames([s.form, s[placement]])}
					onSubmitSuccess={onSubmitSuccess}
					onSubmitError={onSubmitError}
					persistFieldValues={false}
				/>
			</m.div>
		</div>
	)
}

export default NewsletterSignupForm
